let routers = require("./routes").default;
let acl = require("./config_acl").default;

let menu = [
  {
    icon: "home",
    text: "Inicio",
    route: routers.home,
    target: "*",
  },

  {
    icon: "dynamic_feed",
    text: "Transacciones",
    route: routers.cases,
    target: acl.targets.casos,
  },

  {
    text: "Maestros",
    icon: "view_module",
    route: routers.maestros,
    target: acl.targets.maestros,
  },

  // {
  //   icon: "dashboard",
  //   text: "Reportes",
  //   route: routers.reports,
  //   target: acl.targets.reports,
  // },

  {
    icon: "assessment",
    text: "Reportes",
    label_key: "reports_v2",
    route: routers.reports,
    target: acl.targets.reports,
  },

  {
    title: "Procesos",
    icon: "account_balance",
    target: acl.targets.procesos,
    active: false,
    items: [
      {
        text: "Liquidación",
        route: routers.preliquidacion,
        target: acl.targets.preliquidacion,
      },
      {
        text: "Facturación Recurrente",
        route: routers.contratos,
        target: acl.targets.contratos,
      },
      {
        text: "Depreciación",
        route: routers.depreciacion,
        target: acl.targets.depreciacion,
      },
      {
        text: "Reprocesos",
        route: routers.reprocesos,
        target: acl.targets.reprocesos,
      },
      {
        text: "Integración POS",
        route: routers.integracion_pos,
        target: acl.targets.integracion_pos,
      },
      {
        text: "Sincronizar resoluciones",
        route: routers.sincronizar_resoluciones,
        target: acl.targets.sincronizar_resoluciones,
      },
    ],
  },

  // {
  //   title: "Citas",
  //   icon: "event",
  //   target: acl.targets.citas,
  //   active: false,
  //   items: [
  //     {
  //       text: "Ver turnos",
  //       route: routers.ver_turnos,
  //       target: acl.targets.ver_turnos,
  //     },
  //     {
  //       text: "Crear turnos",
  //       route: routers.crear_turnos,
  //       target: acl.targets.crear_turnos,
  //     },
  //     {
  //       text: "Actividades",
  //       route: routers.actividades,
  //       target: acl.targets.actividades,
  //     },
  //   ],
  // },

  {
    icon: "format_list_numbered",
    text: "Mis pendientes",
    route: routers.workflow,
    target: acl.targets.menu_tareas,
  },

  {
    icon: "task_alt",
    text: "Tareas",
    route: routers.admin_tasks,
    target: acl.targets.admin_tasks,
  },

  {
    icon: "analytics",
    text: "Reportes",
    route: routers.reportes,
    target: acl.targets.reportes,
  },

  {
    title: "Configuración",
    icon: "settings",
    target: acl.targets.menu_configuracion,
    active: false,
    items: [
      {
        text: "Editor de plantillas",
        route: routers.plantillas_editor,
        target: acl.targets.plantilla_correo,
      },
      {
        text: "Aplicación Web",
        route: routers.aplicativo,
        target: acl.targets.menu_configuracion,
      },
      {
        text: "Integraciones",
        route: routers.integraciones,
        target: acl.targets.integraciones,
      },
      {
        text: "Formularios",
        route: routers.form_generator,
        target: acl.targets.formularios,
      },
      {
        text: "Protocolos",
        route: routers.protocols,
        target: acl.targets.protocolos,
      },
      // {
      //   text: "Equipos",
      //   route: routers.teams,
      //   target: acl.targets.equipos,
      // },
      // {
      //   text: "Integrantes de equipos",
      //   route: routers.team_assignement,
      //   target: acl.targets.asignaciones,
      // },
      {
        text: "Acciones",
        route: routers.acl_actions,
        target: acl.targets.acciones,
      },
      {
        text: "Módulos",
        route: routers.acl_object_types,
        target: acl.targets.objetos,
      },
      {
        text: "Roles",
        route: routers.acl_roles,
        target: acl.targets.roles,
      },
      {
        text: "Reglas",
        route: routers.acl_rules,
        target: acl.targets.reglas,
      },
      {
        text: "Usuarios",
        route: routers.acl_users,
        target: acl.targets.usuarios,
      },
      // {
      //   text: "Registro de entidad",
      //   route: routers.acl_entidades,
      //   target: acl.targets.entidades,
      // },
    ],
  },
];
export default menu;
